import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import LoginCard from "./LoginCard";
import { useLogin } from "../hooks/useLogin";
import PublicRoute from "./PublicRoute";
import authService from "../services/authService";
import logger from "../../../utils/secureLogger";

const LoginContainer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasCheckedAuth = useRef(false);

  const {
    credentials,
    newPassword,
    loading,
    oktaLoading,
    error,
    needsPasswordChange,
    showDirectLogin,
    handleSubmit,
    handlePasswordChange,
    handleChange,
    setNewPassword,
    handleOktaLogin,
    toggleDirectLogin,
    resetForm,
    clearError,
    isOktaEnabled,
    getOktaConfig,
  } = useLogin();

  useEffect(() => {
    if (hasCheckedAuth.current || location.pathname !== "/login") {
      return;
    }

    const checkAuthStatus = async () => {
      try {
        hasCheckedAuth.current = true;
        logger.debug("🔍 Checking authentication status on login page...");

        const isAuth = await authService.isAuthenticated();
        if (isAuth) {
          logger.debug("✅ User already authenticated, redirecting to dashboard...");
          navigate("/", { replace: true });
        } else {
          logger.debug("🔓 User not authenticated, showing login form");
        }
      } catch (error) {
        logger.debug("❌ Error checking auth status:", error);
        hasCheckedAuth.current = false;
      }
    };

    const timeoutId = setTimeout(checkAuthStatus, 100);
    return () => clearTimeout(timeoutId);
  }, [navigate, location.pathname]);

  return (
    <PublicRoute>
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-900 to-[#F26522]/20 p-4">
        <LoginCard
          credentials={credentials}
          newPassword={newPassword}
          loading={loading}
          oktaLoading={oktaLoading}
          error={error}
          needsPasswordChange={needsPasswordChange}
          showDirectLogin={showDirectLogin}
          handleSubmit={handleSubmit}
          handlePasswordChange={handlePasswordChange}
          handleChange={handleChange}
          handleOktaLogin={handleOktaLogin}
          toggleDirectLogin={toggleDirectLogin}
          setNewPassword={setNewPassword}
          isOktaEnabled={isOktaEnabled}
          getOktaConfig={getOktaConfig}
        />
      </div>
    </PublicRoute>
  );
};

export default LoginContainer;
